import FirstResumeSideComponent from "./components/FirstResumeSideComponent.jsx";
import LastResumeSideComponent from "./components/LastResumeSideComponent.jsx";
import FooterComponent from "./components/FooterComponent.jsx";
import './App.css';

function App() {
  return (
    <main className="container fluid mt-3">
      <div className="row g-5">
        <FirstResumeSideComponent />
        <LastResumeSideComponent />
      </div>
      <FooterComponent />
    </main>
  );
}

export default App;
